import { detectLocale } from "./locale";
import store from "@/store";

export function getAnalyticsContext() {
  const tenant = store.getters["tenant/tenant"];

  return {
    // Language / locale
    locale: detectLocale(),

    // User (future-proof)
    userType: "guest",

    // Platform (future mobile/web split)
    platform: "web",

    // Multi-tenant awareness
    tenantId: tenant?.normalized?.id || null,
    tenantSlug: tenant?.normalized?.handle || null,
    tenantType: tenant ? "organizer" : "trekko",
  };
}
